<template>
  <footer class="py-4" style="background-color: rgb(8, 209, 125);">
    <div class="container mx-auto px-4">
      <p class="text-sm text-center text-black">© Copyright 2026 - Córdoba Tech Week</p>
    </div>
  </footer>
</template>

<script>
import VueScrollTo from 'vue-scrollto';

export default {
  methods: {
    scrollToForm() {
      VueScrollTo.scrollTo('#formulario', 500, {
        easing: 'ease-in-out',
      });
    },
  },  
}

</script>